import Ajax from '../../../common/js/Ajax.js';
import MessageUtils from '../../../common/js/MessageUtils.js';
import Widget from '../../../common/js/Widget.js';

export default class TippspielWidget extends Widget {

	constructor($widget) {
		super($widget);
		Ajax.rpc('/isLoggedIn', type => {
			if (!type && this.isLoginRequired()) {
				window.location.href = '/willkommen';
				return;
			} else if (type !== 'admin' && this.isAdminRequired()) {
				window.location.href = '/';
				return;
			}

			if (type === 'admin') {
				$('.js_admin-nav').removeClass('hidden');
				$('.js_user-nav').removeClass('hidden');
			} else if (type === 'user') {
				$('.js_user-nav').removeClass('hidden');
			}

			this.show();
			this.onLoginReady();
		}, error => {
			this.show();
			MessageUtils.error($widget, 'Es ist leider ein Fehler aufgetreten', error);
		});
	}

	static getFailedMessage() {
		return 'Oh, das hat leider grad nicht geklappt, bitte versuch es später noch einmal';
	}

	onLoginReady() {
	}

	isLoginRequired() {
		return false;
	}

	isAdminRequired() {
		return false;
	}

}
